import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./BattleActionBar.module.scss"
import { IBattleActionBarProps } from "./types"

const BattleActionBarComponent: FC<IBattleActionBarProps> = ({
  actions,
  onAttack,
  onAbility,
  onToggleAuto,
  onFlee
}) => {
  const { t } = useTranslation("battle")

  return (
    <section className={styles.BattleActionBar}>
      <div className={styles.BattleActionBar_row}>
        <button
          type="button"
          className={clsx(styles.BattleActionBar_button, styles.primary)}
          disabled={!actions.attack.enabled}
          onClick={onAttack}
        >
          {t("screen.attack")}
        </button>
        {actions.abilities.map((ability) => (
          <button
            key={ability.abilityId}
            type="button"
            className={styles.BattleActionBar_button}
            disabled={!ability.enabled}
            onClick={() => onAbility(ability.abilityId)}
          >
            {t(`ability.${ability.abilityId}`, {
              defaultValue: ability.abilityId
            })}
            {ability.details.length > 0 && (
              <span className={styles.BattleActionBar_cooldown}>
                {ability.details.map((p) => t(p.key, p.params)).join(" · ")}
              </span>
            )}
          </button>
        ))}
      </div>
      <div className={styles.BattleActionBar_row}>
        <button
          type="button"
          className={clsx(styles.BattleActionBar_button, {
            [styles.active]: actions.autoOn
          })}
          aria-pressed={actions.autoOn}
          disabled={!actions.autoEnabled}
          onClick={onToggleAuto}
        >
          {actions.autoOn ? t("screen.autoOn") : t("screen.autoOff")}
        </button>
        <button
          type="button"
          className={styles.BattleActionBar_button}
          disabled={!actions.fleeEnabled}
          onClick={onFlee}
        >
          {t("screen.flee")}
        </button>
      </div>
    </section>
  )
}

export const BattleActionBar = memo(BattleActionBarComponent)
